import React from 'react'
import AppleIcon from './apple-icon.png'
import ImageButton from './image-button'
import hooks from '../../../hooks'
import { isIOS } from 'react-device-detect'

const AppleButton = () => {
    const { toLocation, endpoints } = hooks.useClientLocation()
    
    const { isAdmin, isBusy } = hooks.useCurrentUser()

    const onClick = React.useCallback(() => {
        toLocation(endpoints.MOBILE_IOS)
    }, [toLocation, endpoints])


    React.useEffect(() => {
        if (!isBusy && !isAdmin && isIOS) {
            onClick()
        }
    }, [isIOS, onClick, isBusy, isAdmin ])

    return (
        <ImageButton src={AppleIcon} onClick={onClick}>IOS</ImageButton>
    )
}

export default AppleButton
